export default {"src":"/_next/static/media/settings-icon.6a386fcd.svg","height":16,"width":16};